import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Faq } from "@/components/Faq";
import { Seo } from "@/components/Seo";
import { PAGE_SEO } from "@/data/seo";

export default function FaqPage() {
  return (
    <main className="min-h-screen" data-testid="faq-page-main">
      <Seo {...PAGE_SEO.faq} />
      <Header />
      <h1 className="sr-only">Frequently Asked Questions — Melbourne Removalists | MoversNearby</h1>
      <div className="pt-24" data-testid="faq-page">
        <Faq />
      </div>
      <Footer />
    </main>
  );
}
